import { Component, EventEmitter, HostBinding, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { iconColors } from '@app/shared/constants/icons-constants';
import { AlertClassEnum } from '@app/shared/enums/alert-class.enum';

@Component({
  selector: 'alert-badge',
  templateUrl: 'alert-badge.component.html',
  styleUrls: ['alert-badge.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AlertBadgeComponent {
  public class = ['alert', 'alert-info'];
  public iconColors = iconColors;
  @Input() public isEmbedded = false;
  @Input() public dismissIcon = true;
  @Input() public warningIcon = false;
  @Input() public set type(type: AlertClassEnum) {
    if (type) this.class[1] = type;
  }
  @Output()
  public dismissed = new EventEmitter();
  @HostBinding('div.class.alert.background') get bgColor() {
    return 'red';
  }
}
